import React from "react";
import ChartsView from "./Charts.view";

const ChartsContainer: React.FC = () => {
  return <ChartsView />;
};

export default ChartsContainer;
